import { Option } from '@code/innovance-react-ui-kit';
import { DictionaryLine } from 'src/front/api/generated';
import { formatDate } from './dateTimeUtils';
import { dictionaryLineFormat } from './formUtils';

export interface FormData {
  customerSurname: string;
  customerName: string;
  customerSecondName: string;
  customerGender: Option | null;
  birthDate: Date | null;
  birthPlaceCountry: Option | null;
  citizenship: Option | null;
  birthPlaceRegion: Option | null;
  residenceCountry: Option | null;
  birthPlaceCity: string;
  hasPreviousSurname: Option | null;
  previousSurname: string;
}

interface IndiviualPageDataRequest {
  customerSurname: string;
  customerName: string;
  customerSecondName: string;
  customerGender?: DictionaryLine;
  birthDate: string;
  birthPlaceCountry?: DictionaryLine;
  citizenship: DictionaryLine;
  birthPlaceRegion: DictionaryLine;
  residenceCountry: DictionaryLine;
  birthPlaceCity: string;
  hasPreviousSurname?: DictionaryLine;
  previousSurname: string;
}

export const createIndividualPageDataForValidation = (
  form: FormData,
  comboItems: Option[]
): IndiviualPageDataRequest => {
  return {
    customerSurname: form.customerSurname,
    customerName: form.customerName,
    customerSecondName: form.customerSecondName,
    customerGender: dictionaryLineFormat(form.customerGender),
    birthDate: formatDate(form.birthDate),
    birthPlaceCountry: dictionaryLineFormat(form.birthPlaceCountry),
    citizenship: dictionaryLineFormat(form.citizenship),
    birthPlaceRegion: dictionaryLineFormat(form.birthPlaceRegion),
    residenceCountry: dictionaryLineFormat(form.residenceCountry),
    birthPlaceCity: form.birthPlaceCity,
    ...(form.hasPreviousSurname
      ? { hasPreviousSurname: dictionaryLineFormat(form.hasPreviousSurname) }
      : { hasPreviousSurname: dictionaryLineFormat(comboItems[0]) }),
    previousSurname: form.previousSurname,
  };
};
